import { useApiBase } from "api/base";
import { useCallback } from "react";
import { ChargeAuthorizationModel } from "../models/charge-authorization-model";
import { VariaveisAmbiente } from "ambiente";

export function usePostChargeAuthorization() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postChargeAuthorization = useCallback(
        (charge: ChargeAuthorizationModel, token: string) => {
            return invocarApi({
                url: `v2/charge/authorization`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                data: JSON.stringify(charge),
                enviarTokenUsuario: false,
                baseURL: VariaveisAmbiente.paymentSafraApi,
            });
        },
        [invocarApi]
    );

    return {
        ...outrasPropriedades,
        postChargeAuthorization,
    };
}